module.exports = __webpack_public_path__ + "img/moon.14e5b16d.png";